<div class="row">
  <div class="col-12 py-5">
    <h4>Organization</h4>
  </div>
</div>

<div class="row">
  <div *ngFor="let organization of subOrgs" routerLink="{{organization.id}}" class="col-md-4 col-sm-6 col6 equel-grid organization-card">
    <div class="grid device-card row">
      <div class="grid-body col-3">
        <img src="{{organization.logo_storage_url}}" class="org-logo" onerror="this.src='/assets/images/logo_placeholder.png'" />
      </div>
      <div class="grid-body text-gray col-9">
        <p class="card-title">{{organization.name}}</p>
        <p class="text-muted">{{organization.city}}, {{organization.province}}</p>
      </div>
    </div>
  </div>
</div>
